import styled from "styled-components";

export const SectionWrapper = styled.section`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  color: #ffffff;
  overflow: hidden;
  background-image: url("/homepage/FinalBackground.webp");
  background-size: cover;
  background-position: center;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0.7) 100%);
    z-index: 1;
  }
`;

export const SectionContent = styled.div`
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  padding: 2.5rem 1.5rem 0;
  width: 100%;
  height: 100%;
  justify-content: space-between;
  flex: 1;

  ${({ theme }) => theme.breakpoints.up("sm")} {
    padding: 3rem 3rem 0;
  }

  ${({ theme }) => theme.breakpoints.up("md")} {
    padding: 3.5rem 4rem 0;
  }

  ${({ theme }) => theme.breakpoints.up("laptopL")} {
    padding: 4rem 6rem 0;
  }
`;

export const TopRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  width: 100%;

  ${({ theme }) => theme.breakpoints.up("sm")} {
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    gap: 2.5rem;
  }

  ${({ theme }) => theme.breakpoints.up("md")} {
    gap: 3.5rem;
  }
`;

export const TopLeftSection = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  max-width: 35rem;
  min-width: 0;

  ${({ theme }) => theme.breakpoints.up("laptopL")} {
    max-width: 45rem;
  }
`;

export const TopRightSection = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  max-width: 35rem;
  gap: 2rem;

  ${({ theme }) => theme.breakpoints.up("laptopL")} {
    max-width: 45rem;
  }
`;
export const Title = styled.h2`
  font-family: ${({ theme }) => theme.fonts.body};
  font-weight: 400;
  font-size: 1.5rem;
  line-height: 1.1;
  margin: 0 0 0.75rem;

  em, i {
    font-family: ${({ theme }) => theme.fonts.display};
    font-style: italic;
    font-weight: 400;
    color: ${({ theme }) => theme.palette.redesign.pink};
  }

  ${({ theme }) => theme.breakpoints.up("sm")} {
    font-size: 3.5rem;
    margin-bottom: 1rem;
  }

  ${({ theme }) => theme.breakpoints.up("md")} {
    font-size: 4.25rem;
  }

  ${({ theme }) => theme.breakpoints.up("laptopL")} {
    font-size: 5rem;
  }
`;

export const Subtitle = styled.p`
  font-family: ${({ theme }) => theme.fonts.body};
  font-weight: 400;
  font-size: 0.925rem;
  line-height: 1.5;
  margin: 0;
  opacity: 0.9;

  ${({ theme }) => theme.breakpoints.up("sm")} {
    font-size: 1.125rem;
  }

  ${({ theme }) => theme.breakpoints.up("laptopL")} {
    font-size: 1.25rem;
  }
`;

export const ContactList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  ${({ theme }) => theme.breakpoints.down("sm")} {
    gap:0.5rem;
  }
`;

export const ContactItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-family: ${({ theme }) => theme.fonts.body};
  font-weight: 400;
  font-size: 0.725rem;

  ${({ theme }) => theme.breakpoints.up("sm")} {
    font-size: 1rem;
  }
  
  svg {
    width: 2rem;
    height: 2rem;
    padding: 0.5rem;
    background: rgba(255,255,255,0.2);
    border-radius: 50%;

    ${({ theme }) => theme.breakpoints.up("sm")} {
      width: 2.5rem;
      height: 2.5rem;
      padding: 0.6rem;
    }
  }

  span {
    white-space: pre-wrap;
  }
`;

export const BottomSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 2rem;

  ${({ theme }) => theme.breakpoints.up("sm")} {
    margin-top: 2.5rem;
  }
`;

export const CopyrightWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 0.5rem;
  margin-bottom: 1rem;
  ${({ theme }) => theme.breakpoints.down("sm")} {
    gap:0;
  }
`;

export const CopyrightText = styled.span`
  font-family: ${({ theme }) => theme.fonts.body};
  font-weight: 400;
  font-size: 0.725rem;
  opacity: 0.9;

  ${({ theme }) => theme.breakpoints.up("sm")} {
    font-size: 1.175rem;
  }
`;

export const Slogan = styled.span`
  font-family: ${({ theme }) => theme.fonts.body};
  font-weight: 400;
  font-size: 0.925rem;
  letter-spacing: 0.05em;

  ${({ theme }) => theme.breakpoints.up("sm")} {
    font-size: 1.825rem;
  }
`;

export const FinalSectionCta = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.65rem 1.5rem;
  margin-top: 2rem;
  border: 1.5px solid rgba(255, 255, 255, 0.55);
  border-radius: 9999px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  color: #fff;
  font-family: ${({ theme }) => theme.fonts.body};
  font-weight: 400;
  font-size: 0.875rem;
  letter-spacing: 0.04em;
  cursor: pointer;
  transition: background 0.22s ease, border-color 0.22s ease, transform 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.22);
    border-color: rgba(255, 255, 255, 0.9);
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }

  svg {
    transition: transform 0.2s ease;
    width: 14px;
    height: 14px;
  }

  &:hover svg {
    transform: translateX(3px);
  }

  ${({ theme }) => theme.breakpoints.up("sm")} {
    font-size: 1rem;
    padding: 0.75rem 1.5rem;
    svg { width: 16px; height: 16px; }
  }

  ${({ theme }) => theme.breakpoints.up("md")} {
    font-size: 1.125rem;
    padding: 0.85rem 1.75rem;
    svg { width: 18px; height: 18px; }
  }

  ${({ theme }) => theme.breakpoints.up("laptop")} {
    font-size: 1.25rem;
    padding: 1rem 2rem;
    svg { width: 20px; height: 20px; }
  }

  ${({ theme }) => theme.breakpoints.up("laptopL")} {
    font-size: 1.375rem;
    padding: 1.1rem 2.25rem;
    svg { width: 22px; height: 22px; }
  }
`;

/* ── Social Elements ──────────────────────────────────────── */

export const SocialRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

export const SocialSectionLabel = styled.span`
  font-family: ${({ theme }) => theme.fonts.body};
  font-weight: 400;
  font-size: 0.65rem;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  opacity: 0.9;
  color: #fff;

  ${({ theme }) => theme.breakpoints.up("sm")} {
    font-size: 0.75rem;
  }
`;

export const SocialChipsContainer = styled.div`
  display: flex;
  gap: 0.625rem;
  flex-wrap: wrap;
`;

export const SocialChip = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.25rem;
  height: 2.25rem;
  border-radius: 0.625rem;
  border: 1.5px solid rgba(255, 255, 255, 0.18);
  background: rgba(255, 255, 255, 0.06);
  color: #ffffff;
  cursor: pointer;
  transition: border-color 0.25s ease, background 0.25s ease, box-shadow 0.25s ease, transform 0.2s ease;
  flex-shrink: 0;
  outline: none;
  padding: 0;

  &:hover {
    border-color: rgba(255, 255, 255, 0.4);
    background: rgba(255, 255, 255, 0.14);
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0) scale(0.96);
  }

  ${({ theme }) => theme.breakpoints.up("sm")} {
    width: 3.5rem;
    height: 3.5rem;
  }

  ${({ theme }) => theme.breakpoints.up("laptopL")} {
    width: 4rem;
    height: 4rem;
  }
`;

export const SocialChipIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.1rem;
  height: 1.1rem;
  transition: transform 0.3s ease;

  svg {
    width: 100%;
    height: 100%;
    stroke-width: 1.75;
  }

  ${({ theme }) => theme.breakpoints.up("sm")} {
    width: 2rem;
    height: 2rem;
  }

  ${({ theme }) => theme.breakpoints.up("laptopL")} {
    width: 2.5rem;
    height: 2.5rem;
  }
`;
